<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <b-modal
        id="filter"
        size="lg"
        no-close-on-backdrop
        hide-footer
        title="FILTRAR"
      >
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pt-0">
            <h6>TODOS OS USUÁRIOS?</h6>
            <div class="row">
              <b-form-radio
                @input="handleSelectUsers"
                v-model="selectAllUsers"
                :value="true"
                class="mr-2 ml-2"
                >SIM</b-form-radio
              >
              <b-form-radio
                @input="handleSelectUsers"
                v-model="selectAllUsers"
                :value="false"
                class="mr-2 ml-2"
                >NÃO</b-form-radio
              >
            </div>
            <div class="pt-0 pb-0" v-show="!selectAllUsers">
              <h6>SELECIONE OS USUARIOS:</h6>
              <b-form-checkbox-group
                v-model="user_ids"
                style="height: 200px; overflow-y: scroll"
              >
                <b-form-checkbox
                  @input="handleChangeCheckboxUser"
                  class="
                    ml-4
                    col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
                    pb-0
                    pt-0
                  "
                  v-for="user in users"
                  :key="user.id"
                  :value="user.id"
                >
                  {{ String(user.name).toUpperCase() }}
                </b-form-checkbox>
              </b-form-checkbox-group>
            </div>
          </div>
          <div class="col-xl-6 col-sm-6 col-md-6 col-sm-6 col-6 pb-0">
            <h6 class="upper-text">Filtrar por anotação/sinais vitais:</h6>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="filter_annotation"
                id="filter_annotation"
              />
              <label class="form-check-label" for="filter_annotation">
                ANOTAÇÕES
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="filter_vital_signs"
                id="filter_vital_signs"
              />
              <label class="form-check-label" for="filter_vital_signs">
                SINAIS VITAIS
              </label>
            </div>
          </div>
          <div class="col-xl-4 col-sm-4 col-md-4 col-sm-4 col-4 text-center">
            <label>FILTRAR POR RESIDENTES</label>
            <div class="d-flex align-items-center justify-content-center">
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_active"
                  @change="getResidents"
                  id="resident_active"
                />
                <label class="form-check-label" for="resident_active">
                  ATIVOS
                </label>
              </div>
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_not_active"
                  @change="getResidents"
                  id="resident_not_active"
                />
                <label class="form-check-label" for="resident_not_active">
                  INATIVOS
                </label>
              </div>
            </div>
          </div>
          <div class="col-xl-8 col-sm-8 col-md-8 col-sm-8 col-8 pt-0">
            <h6 class="upper-text mt-3 mb-1">Filtrar por residente:</h6>
            <select v-model="resident_id" class="form-control">
              <option
                v-for="resident in residents"
                :key="resident.id"
                :value="resident.id"
              >
                {{ String(resident.name).toUpperCase() }} -
                {{ String(resident.status_type_name).toUpperCase() }}
              </option>
            </select>
          </div>
          <div class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 pt-0">
            <h6 class="upper-text mt-3 mb-1">Filtrar por status:</h6>
            <select v-model="status" class="form-control">
              <option
                v-for="item in typesFilterByStatus"
                :key="item.id"
                :value="item.id"
              >
                {{ String(item.name).toUpperCase() }}
              </option>
            </select>
          </div>
          <div class="col-xl-6 col-sm-6 col-md-6 col-sm-6 col-6 pt-0">
            <h6 class="upper-text mt-3 mb-1">Filtrar por data inicial:</h6>
            <input type="date" v-model="dtInit" class="form-control" />
          </div>
          <div class="col-xl-6 col-sm-6 col-md-6 col-sm-6 col-6 pt-0">
            <h6 class="upper-text mt-3 mb-1">Filtrar por data final:</h6>
            <input type="date" v-model="dtEnd" class="form-control" />
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
            <ErrorsMessages :errors="errors" />
          </div>
          <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
          >
            <v-btn
              :disabled="loading"
              @click="paginate()"
              class="btn-filter"
              type="relief"
              ><i class="fas fa-filter mr-2 text-twenty"></i>
              {{ loading ? "CARREGANDO" : "FILTRAR" }}
            </v-btn>
          </div>
        </div>
      </b-modal>
      <div class="row">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return mb-3" v-on:click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> VOLTAR
          </v-btn>
        </div>
        <div class="col-xl-5 col-lg-5 col-md-6 col-sm-9 col-12 pt-0">
          <h3 class="title-pages pt-1">
            RELATÓRIO: CUIDADOS - ANOTAÇÃO / SINAIS VITAIS
          </h3>
        </div>
        <div
          class="col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12 pt-0 text-right"
        >
          <v-btn
            @click="$bvModal.show('filter')"
            class="btn-filter mr-2"
            type="relief"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
          <v-btn
            :disabled="cares.length == 0"
            @click="handleToPrint"
            class="btn-print"
            type="relief"
          >
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0"
          v-if="cares.length > 0"
        >
          <h6 class="mb-0 upper-text worksansr check-text-center">
            FILTRANDO:
            <span v-if="selectAllUsers">
              <strong>TODOS OS USUÁRIOS </strong>|
            </span>
            <span v-if="filter_annotation"><strong>ANOTAÇÕES </strong>| </span>
            <span v-if="filter_vital_signs"
              ><strong>SINAIS VITAIS </strong>|
            </span>
            <span
              ><strong>STATUS: {{ status }}</strong> |
            </span>
            <span
              ><strong>DATA INICIAL: {{ formatDate(dtInit, false) }} </strong>|
            </span>
            <span
              ><strong>DATA FINAL: {{ formatDate(dtEnd, false) }} </strong>|
            </span>
          </h6>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <div class="v-clean p-5 text-center" v-show="cares.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <v-data-table
          v-show="cares.length > 0"
          dense
          :headers="headers"
          :items="cares"
          item-key="id-itemType"
          :footer-props="{
            'items-per-page-options': [50, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
          @click:row="handleClickRowTable"
        >
          <template v-slot:[`item.type`]="{ item }">{{
            handleType(item.type, item.itemType)
          }}</template>
          <template v-slot:[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at) }}</template
          >
          <template v-slot:[`item.itemType`]="{ item }">
            <div>
              <h6
                v-if="item.itemType == 'annotation'"
                :class="[
                  'mb-0 worksansr',
                  'text-success',
                  item.status == 'A' && 'text-warning',
                ]"
              >
                {{ item.status == "A" ? "EM ABERTO" : "FINALIZADO" }}
              </h6>
              <h6
                v-if="item.itemType == 'vital_sign'"
                class="mb-0 worksansr text-success"
              >
                FINALIZADO
              </h6>
            </div>
          </template>
        </v-data-table>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import routes from "../../routes";

import { formatDate } from "../../lib/format";

import AuthBySessionExpired from "../Components/AuthBySessionExpired";

import ErrorsMessages from "../Components/ErrorsMessages";

import NavBar from "../NavBar";

import { userData, restore, save } from "../../lib/functions";

export default {
  name: "ReportsCare",
  components: {
    NavBar,
    ErrorsMessages,
    AuthBySessionExpired,
  },
  data() {
    return {
      filter_annotation: false,
      filter_vital_signs: false,
      resident_active: true,
      resident_not_active: false,
      user_ids: [],
      selectAllUsers: true,
      dtInit: "",
      dtEnd: "",
      status: "TODOS",
      user_id: "ALL",
      resident_id: "",
      headers: [
        { text: "TIPO", sortable: false, value: "type" },
        { text: "RESIDENTE", value: "resident_name" },
        { text: "CRIADO POR", value: "user_name" },
        { text: "DATA CADASTRO", value: "created_at" },
        { text: "STATUS", value: "itemType" },
      ],
      typesFilterByStatus: [
        { id: "TODOS", name: "Filtrar por todos" },
        { id: "ABERTO", name: "Filtrar apenas em aberto" },
        {
          id: "FINALIZADO",
          name: "Filtrar apenas finalizados",
        },
      ],
      residents: [],
      users: [],
      cares: [],
      errors: [],
      rest_home_id: "",
      loading: false,
      interactCheckBoxUsers: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    saveState() {
      save(this, "ReportsAnnotation", [
        "filter_annotation",
        "filter_vital_signs",
        "resident_id",
        "status",
        "dtInit",
        "dtEnd",
        "user_id",
      ]);
    },
    handleChangeCheckboxUser(e) {
      if (e.length > 0) {
        if (this.user_ids.length != this.users.length) {
          this.interactCheckBoxUsers = true;
        } else {
          this.interactCheckBoxUsers = false;
        }
        if (this.user_ids.length != this.users.length) {
          this.selectAllUsers = false;
        } else {
          this.selectAllUsers = true;
        }
      } else {
        this.interactCheckBoxUsers = false;
      }
    },
    handleSelectUsers(e) {
      if (e) {
        this.user_ids = this.users.map(({ id }) => id);
      } else {
        if (!this.interactCheckBoxUsers) {
          this.user_ids = [];
        }
      }
    },
    handleType(type, itemType) {
      var show = {
        CUIDADOR_ENFERMAGEM: "CUIDADOR/ENFERMAGEM",
        ENFERMEIRA: "ENFERMEIRA",
        MEDICO: "MÉDICO",
        EQUIPE_MULTIDISCIPLINAR: "EQUIPE MULTIDISCIPLINAR",
        default: "TIPO NÃO ENCONTRADO!",
      };

      return `${show[type] || show.default} - ${
        itemType == "annotation" ? "ANOTAÇÃO" : "SINAIS VITAIS"
      }`;
    },
    handleClickRowTable({ id, itemType }) {
      if (itemType == "annotation") {
        routes.push({ name: "care", params: { id } });
      } else if (itemType == "vital_sign") {
        routes.push({ name: "vital_sign", params: { id } });
      }
    },
    async retrieve() {
      const { user } = userData();

      this.rest_home_id = user.rest_home_id;

      restore(this, "ReportsAnnotation");

      if (this.errors.length == 0) await this.getResidents();
      if (this.errors.length == 0) await this.getUsers();
      if (this.resident_id && this.errors.length == 0) await this.paginate();

      let { modal } = this.$router.currentRoute.query;

      if (modal) {
        this.$bvModal.show("filter");
      }
    },
    async getResidents() {
      try {
        let { resident_active, resident_not_active } = this;

        let status = "ATIVO";

        if (resident_active && resident_not_active) {
          status = "ALL";
        } else if (!resident_active && resident_not_active) {
          status = "INATIVO";
        } else if (!resident_active && !resident_not_active) {
          this.errors = [
            {
              id: this.errors.length,
              message: "Informe residentes ativos, inativos ou ambos",
            },
          ];
          this.residents = [];
          return;
        }

        let params = { status };

        const response = await api.get("/rest-home/resident/paginate", {
          params,
        });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getUsers() {
      try {
        const { rest_home_id } = this;

        let params = { rest_home_id };

        const response = await api.get("/rest-home/user/all", {
          params,
        });

        const { error, errors, users } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.users = users;
          this.user_ids = users.map(({ id }) => id);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async paginate() {
      try {
        this.loading = true;

        const {
          dtInit,
          dtEnd,
          status,
          resident_id,
          user_ids,
          filter_annotation,
          filter_vital_signs,
        } = this;

        var params = {
          resident_id,
          user_ids,
          dtInit,
          dtEnd,
          status,
          filter_annotation,
          filter_vital_signs,
        };

        const response = await api.get("/rest-home/report/annotation/filter", {
          params,
        });

        const { cares, error, errors } = response.data;

        if (error) {
          this.cares = [];
          this.errors = errors;
        } else {
          this.errors = [];
          this.cares = cares;
          this.$bvModal.hide("filter");
        }

        this.saveState();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleToPrint() {
      const { cares } = this;

      let care_ids = [];
      let vital_sign_ids = [];

      for (const item of cares) {
        if (item.itemType == "annotation") {
          care_ids.push(item.id);
        } else {
          vital_sign_ids.push(item.id);
        }
      }

      let route = this.$router.resolve({
        name: "report_annotation",
        params: {
          resident_id: this.resident_id,
          care_ids: care_ids.join(",") || false,
          vital_sign_ids: vital_sign_ids.join(",") || false,
        },
      });

      window.open(route.href, "_blank");
    },
    handleToBack: () => routes.go(-1),
  },
};
</script>
